import { motion } from "framer-motion";

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; };
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -20, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, dark = false }) => (
  <span className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-[0.18em] ${dark ? "bg-white/10 text-sun" : "bg-plum/10 text-plum"}`}>
    {children}
  </span>
);

export const SectionTitle = ({ children, className = "" }) => (
  <h2 className={`font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl ${className}`}>
    {children}
  </h2>
);
